export const DeviceMobileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g id="tabler:device-mobile-cog">
        <path
          id="Vector"
          d="M12.5 21.708H8.5C7.96957 21.708 7.46086 21.4973 7.08579 21.1222C6.71071 20.7471 6.5 20.2384 6.5 19.708V5.70801C6.5 5.17757 6.71071 4.66887 7.08579 4.29379C7.46086 3.91872 7.96957 3.70801 8.5 3.70801H16.5C17.0304 3.70801 17.5391 3.91872 17.9142 4.29379C18.2893 4.66887 18.5 5.17757 18.5 5.70801V12.208M11.5 4.70801H13.5M12.5 17.708V17.718M19.501 21.708C18.9706 21.708 18.4619 21.4973 18.0868 21.1222C17.7117 20.7471 17.501 20.2384 17.501 19.708C17.501 19.1776 17.7117 18.6689 18.0868 18.2938C18.4619 17.9187 18.9706 17.708 19.501 17.708M19.501 21.708C20.0314 21.708 20.5401 21.4973 20.9152 21.1222C21.2903 20.7471 21.501 20.2384 21.501 19.708C21.501 19.1776 21.2903 18.6689 20.9152 18.2938C20.5401 17.9187 20.0314 17.708 19.501 17.708M19.501 21.708V23.208M19.501 17.708V16.208M22.532 17.958L21.233 18.708M17.77 20.708L16.47 21.458M16.47 17.958L17.77 18.708M21.233 20.708L22.533 21.458"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
